export function loadScript(src, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = src
  if (callback) script.onload = callback
  document.body.appendChild(script)
}

export function initMaps() {
  console.log('maps API has been loaded')
}

export function getMapStyle() {
  const mainColor = '#222222'
  const saturationValue = -100
  const brightnessValue = 5
  //we define here the style of the map
  const style = [
    {
      //set saturation for the labels on the map
      elementType: 'labels',
      stylers: [{ saturation: saturationValue }],
    },
    {
      //poi stands for point of interest - don't show these lables on the map
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      //don't show highways lables on the map
      featureType: 'road.highway',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      //don't show local road lables on the map
      featureType: 'road.local',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      //don't show arterial road lables on the map
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      //don't show road lables on the map
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ visibility: 'off' }],
    },
    //style different elements on the map
    {
      featureType: 'transit',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'poi.government',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'poi.sport_complex',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'poi.attraction',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'poi.business',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'transit.station',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'landscape',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        { hue: mainColor },
        { visibility: 'on' },
        { lightness: brightnessValue },
        { saturation: saturationValue },
      ],
    },
  ]

  return style
}

export function getMapMarker(iconName) {
  const internetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1
  const markerUrl = internetExplorer11
    ? `${theme.theme_directory}/img/icons/${iconName}.png`
    : `${theme.theme_directory}/img/icons/${iconName}.svg`

  return markerUrl
}
